import { PaymentConfig } from '../types/booking';

export function getRequiredDepositPercentage(
  paymentConfig: PaymentConfig | undefined,
  dateStr: string,
  timeStr: string
): 0 | 25 | 50 | 100 {
  if (!paymentConfig) return 0;

  // Evaluate rules if they exist
  if (paymentConfig.rules && paymentConfig.rules.length > 0) {
    // Parse date to get dayOfWeek
    // dateStr is 'YYYY-MM-DD'
    // To avoid timezone issues, split and create Date in local
    const [y, m, d] = dateStr.split('-');
    const dateObj = new Date(Number(y), Number(m) - 1, Number(d));
    const dayOfWeek = dateObj.getDay(); // 0 = Sunday

    // Parse time for comparison
    const timeToMin = (t: string) => {
      const [hh, mm] = t.split(':').map(Number);
      return hh * 60 + mm;
    };
    const currentMins = timeToMin(timeStr);

    for (const rule of paymentConfig.rules) {
      if (rule.daysOfWeek.includes(dayOfWeek)) {
        const startMins = timeToMin(rule.startHour);
        const endMins = timeToMin(rule.endHour);
        if (currentMins >= startMins && currentMins <= endMins) {
          return rule.depositPercentage;
        }
      }
    }
  }

  // Fallback to defaultPercentage if set
  if (paymentConfig.defaultPercentage !== undefined) {
    return paymentConfig.defaultPercentage;
  }

  // Fallback to legacy policy handling for backward compatibility
  if (paymentConfig.paymentPolicy === 'full_payment_required' || paymentConfig.paymentPolicy === 'full_upfront') return 100;
  if (paymentConfig.paymentPolicy === 'deposit_required') {
    const fraction = paymentConfig.depositFraction || 4;
    const perc = 100 / fraction;
    return (perc === 25 || perc === 50 || perc === 100) ? (perc as 25 | 50 | 100) : 25;
  }
  return 0;
}
